import { api } from '../../services/api'
import { showSuccess, showError } from '../misc/misc.actions'

export const updateVisitLineItem = (id, updates) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_VISIT_ITEM' })
		return api
			.patch(`/line-items/${id}`, updates)
			.then((response) => {
				dispatch({ type: 'UPDATE_VISIT_ITEM_SUCCESS', payload: response.data })

				dispatch(showSuccess('Item updated successfully.'))
			})
			.catch(() => {
				dispatch({ type: 'UPDATE_VISIT_ITEM_FAIL' })
				dispatch(showError('An error occured while updating this item.'))
			})
	}
}

export const deleteLineItem = (item) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_VISIT_ITEM' })
		return api
			.delete(`/line-items/${item._id}`)
			.then((response) => {
				dispatch({ type: 'DELETE_VISIT_ITEM_SUCCESS', payload: item })

				dispatch(showSuccess('Item deleted successfully.'))
			})
			.catch(() => {
				dispatch({ type: 'UPDATE_VISIT_ITEM_FAIL' })
				dispatch(showError('An error occured while deleting this item.'))
			})
	}
}